import axios from 'axios'
import commonMethods from '@/commonMethods'
import i18n from '@/plugins/i18n'

const { registerError } = commonMethods()

function savePersonalData(personalData) {
  return new Promise((resolve, reject) => {
    // El idioma que el visitante tiene elegido EN LA WEB, que no tiene por
    // que ser el de su navegador.
    const lang = i18n.global.locale.value ?? i18n.global.locale
    let url = `${process.env.VUE_APP_PATH}saveAppointment?lang=${lang}`
    axios
      .post(url, personalData)
      .then((response) => resolve(response.data))
      .catch((err) => {
        registerError(err, 'Error en savePersonalData')
        reject(err)
      })
  })
}

export default savePersonalData
